export const setCookie = (name, value, expiryDays) => {
  const date = new Date()
  date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000))
  let expires = `expires=${date.toUTCString()}`
  document.cookie = `${name}=${value};${expires};path=/`
}
